import { ajaxSend } from 'api/api';
// TODO [TEAMS-7073]: once RTK Q is ready this file should be removed.
const basePath = 'v3/conversations';
// TODO [TEAMS-7073]: once RTK Q is ready this function should be removed.
export function getConversations({ params = {}, path = basePath, }) {
    return ajaxSend({
        path,
        params,
    });
}
